export default function (value){
    if(!(typeof value === "number" || typeof value === "string")){
        return value;
    }
    if(typeof value === "number"){
        value = value.toString()
    }
    return value.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, '.');
}